/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   aex\service\user\server\clientgeneratorconfigs\genclient.json
 */

export interface UserAadMembershipData {
    aadGroupNames: string;
    count: number;
}
